module.exports = {
    silentLogout(logoutUrl, loginUrl, loginData) {
        let self = this;
        $.ajax({
            url: logoutUrl,
            method: 'POST',
            data: {},
            dataType: 'json',
        }).done(function(res) {
            if (res.logout) {
                self.silentLogin(loginUrl, loginData);
            } else {
                throw new Error('Error during logout.');
            }
        })
    },
    silentLogin(loginUrl, loginData) {
        $.ajax({
            url: loginUrl,
            method: 'POST',
            data: loginData,
            dataType: 'json',
            success: function(res) {
                location.reload();
            }
        })
    }
}